import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-82f94c0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slider" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "carousel-indicators" }
const _hoisted_4 = ["data-bs-target", "data-bs-slide-to"]
const _hoisted_5 = { class: "carousel-inner" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "carousel-caption"
}
const _hoisted_8 = { class: "carousel-caption-title mb-5" }
const _hoisted_9 = ["data-bs-target"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "carousel-control-prev-icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["data-bs-target"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "carousel-control-next-icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: _ctx.id,
      class: "carousel slide",
      "data-bs-ride": "carousel"
    }, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.list)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.list, (item, index) => {
              return (_openBlock(), _createElementBlock("button", {
                key: index,
                type: "button",
                "data-bs-target": `#${_ctx.id}`,
                "data-bs-slide-to": index,
                class: _normalizeClass(item.activeStatus ? 'active' : ''),
                "aria-current": "true"
              }, null, 10, _hoisted_4))
            }), 128))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.list)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.list, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["carousel-item", item.activeStatus ? 'active' : '']),
                "data-bs-interval": "3000"
              }, [
                _createElementVNode("img", {
                  src: item.image,
                  alt: "..."
                }, null, 8, _hoisted_6),
                (item.title || item.description)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("h1", _hoisted_8, _toDisplayString(item.title), 1),
                      _createElementVNode("p", null, _toDisplayString(item.description), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        class: "carousel-control-prev",
        type: "button",
        "data-bs-target": `#${_ctx.id}`,
        "data-bs-slide": "prev"
      }, _hoisted_11, 8, _hoisted_9),
      _createElementVNode("button", {
        class: "carousel-control-next",
        type: "button",
        "data-bs-target": `#${_ctx.id}`,
        "data-bs-slide": "next"
      }, _hoisted_14, 8, _hoisted_12)
    ], 8, _hoisted_2)
  ]))
}